import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">ArcaCapitalis</h3>
            <p className="footer-text">
              Strategic Business Building for Entrepreneurs and Growing Companies
            </p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-subtitle">Contact</h4>
            <p className="footer-text">
              General: info@arcacapitalis.com<br />
              Support: support@arcacapitalis.com
            </p>
          </div>

          <div className="footer-section">
            <p className="footer-disclaimer">
              ArcaCapitalis provides strategic research, operational structuring, and business 
              consulting services. We do not provide legal, tax, or investment advice.
            </p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} ArcaCapitalis. All rights reserved.
          </p>
          <p className="footer-parent-company">
            A product of ArcaCentum, Inc. · <a href="https://arcacentum.com" target="_blank" rel="noopener noreferrer" className="footer-parent-link">Visit ArcaCentum</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;